<template>
  <div class="add-button-dialog-container" v-if="show">
    <div class="add-button" :style="addButtonStyle" @click="onAddButtonClicked">
      &#x271A;
    </div>
  </div>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },

    bottom: {
      type: Number,
      default: 50
    }
  },

  methods: {
    onAddButtonClicked() {
      this.$emit("onAddButtonClicked");
    }
  },

  computed: {
    addButtonStyle() {
      const screenWidth = window.outerWidth;
      let right = 10;
      if (screenWidth > 450) {
        right = (screenWidth / 2) - 220;
      }

      return {right: right + "px", bottom: this.bottom + "px"};
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.add-button-dialog-container {
  position: fixed;
  z-index: 10000;
  max-width: 48px;
  max-height: 48px;
}

.add-button {
  position: fixed;
  height: 48px;
  width: 48px;
  border-radius: 40px;
  background: #1976d2;
  line-height: 48px;
  color: #FFFFFF;
  text-align: center;
  font-size: 16px;
  box-shadow: 3px 1px 7px 0 #5a5959;
  cursor: pointer;
}
</style>
